import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchCriteria = createAsyncThunk(
  "coupons/fetchCriteria",
  async () => {
    const response = await apiCustom.get("criteria-show");
    return response.data?.data?.data;
  }
);
export const createCriteria = createAsyncThunk(
  "coupons/createCriteria",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/criteria-create", newPost, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateCriteria = createAsyncThunk(
  "coupons/updateCriteria",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/criteria-update/${id}`, newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deleteCriteria = createAsyncThunk(
  "coupons/deleteCriteria",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/criteria-delete/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const criteriaSlice = createSlice({
  name: "criteria",
  initialState: {
    criteria: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCriteria.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCriteria.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.criteria = action.payload;
      })
      .addCase(fetchCriteria.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createCriteria.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updateCriteria.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deleteCriteria.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default criteriaSlice.reducer;
